import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { schoolConfig } from "./core/config";
import { AppEventComponent } from "./shared/components/app-event/app-event.component";
import { PrimeNGModule } from "./shared/modules/primeng/primeng.module";

@Component({
    selector: "app-root",
    standalone: true,
    imports: [CommonModule, RouterOutlet, PrimeNGModule, AppEventComponent],
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
    publicUrls = ["/", "/create-enquiry", "/admission", "/components", "/login", "/register", "/id-card-form"];
    privateUrls = ["/student"];
    userData = null;
    ref: any = null;

    // constructor(private sessionMonitorService: SessionMonitorService) {}

    ngOnInit() {
        // Initialize session monitoring
        // this.setupErrorHandling();
        // Initialize the session monitor service
        // we need to set colours of app from app config which will override colour variables in _colors.scss
        const appConfig = schoolConfig;
        document.documentElement.style.setProperty("--app-primary", appConfig.theme.primary);
        document.documentElement.style.setProperty("--app-primary-light", appConfig.theme["primary-light"]);
        document.documentElement.style.setProperty("--app-primary-dark", appConfig.theme["primary-dark"]);
        document.documentElement.style.setProperty("--app-heading-text", appConfig.theme["heading-text"]);
        document.documentElement.style.setProperty("--app-background", appConfig.theme.background);
    }

    // private setupErrorHandling() {
    //     // Handle module loading errors
    //     window.addEventListener("error", (event) => {
    //         if (event.message && event.message.includes("Failed to load module script")) {
    //             // Handle module loading failure - likely session timeout
    //             console.warn("Module loading failed, checking session status...");
    //             this.handleModuleLoadingError();
    //         }
    //     });

    //     // Handle unhandled promise rejections
    //     window.addEventListener("unhandledrejection", (event) => {
    //         if (event.reason && event.reason.message && event.reason.message.includes("Failed to load module script")) {
    //             console.warn("Module loading promise rejected, checking session status...");
    //             this.handleModuleLoadingError();
    //         }
    //     });
    // }

    // private handleModuleLoadingError() {
    //     // Check if we're on a private route and redirect to login if needed
    //     const currentPath = window.location.pathname;
    //     const isPrivateRoute = this.privateUrls.some((url) => currentPath.startsWith(url));

    //     if (isPrivateRoute) {
    //         // Redirect to login page
    //         window.location.href = "/login";
    //     }
    // }
}
